<template>
  <v-card :elevation="2">
    <div>
      <v-card-title style="padding: 8px 8px" v-if="showTitle">
        <div style="flex: 1; align-items: center">
          {{ geBlockNameByBlockType(block.type) }}

          <span v-for="user in onlineUsers" :key="user.id">
            <UserAvatar
              v-if="isUserEditingBlock(user.editingBlockId, block.id)"
              :avatarUrl="user.avatarUrl"
              :fullName="user.fullName"
              :title="user.fullName + ' is working on this block'"
            />
          </span>
        </div>

        <v-btn icon title="Close block editor" @click="$emit('close-click')">
          <v-icon small>mdi-arrow-left</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-alert type="info" dense v-if="block.isReferenced" border="left" text>
        This block is defined in
        <strong v-if="block.createdInProject"
          >{{ block.createdInProject }}&nbsp;>&nbsp;</strong
        >
        <strong>{{ block.referencedFromPage }}</strong> page and reused here.
      </v-alert>
      <div v-if="!block.isReferenced">
        <v-tabs v-model="selectedTab">
          <v-tab> <v-icon small left>mdi-cog-outline</v-icon>Config</v-tab>
          <v-tab> <v-icon small left>mdi-palette-outline</v-icon>Style</v-tab>
          <v-tab> <v-icon small left>mdi-share-variant</v-icon>Share</v-tab>
          <!-- <v-tab>
            <v-icon small left>mdi-history</v-icon>Revisions
          </v-tab> -->
        </v-tabs>
        <div class="pa-2">
          <v-tabs-items v-model="selectedTab">
            <v-tab-item :key="0">
              <slot />
            </v-tab-item>
            <v-tab-item :key="1">
              <BaseBlockStyleBar :block="block"></BaseBlockStyleBar>
            </v-tab-item>
            <v-tab-item :key="2">
              <BlockShareSettings :block="block"></BlockShareSettings>
            </v-tab-item>
            <!-- <v-tab-item :key="3"> -->
            <!-- prevent component caching with v-if -->
            <!-- <BlockRevisions :block="block" v-if="selectedTab === 3"></BlockRevisions> -->
            <!-- </v-tab-item> -->
          </v-tabs-items>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import projectMixin from "./../project-mixin";
import BaseBlockStyleBar from "./BaseBlockStyleBar";
import BlockShareSettings from "./BlockShareSettings";
import UserAvatar from "../../UserAvatar";
// import BlockRevisions from "./BlockRevisions";

export default {
  components: { BaseBlockStyleBar, BlockShareSettings, UserAvatar },
  props: ["block", "showTitle"],
  name: "BaseBlock",
  mixins: [projectMixin],
  data() {
    return {
      selectedTab: 0,
    };
  },
  methods: {
    isUserEditingBlock(userBlockId, blockId) {
      return userBlockId == blockId;
    },
  },
};
</script>

<style scoped>
.sidenav {
  overflow-y: auto;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 999;
  padding: 3rem 20px 2rem 20px;
  width: 500px;
}
.sidenav-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
}

.v-tab {
  font-size: 12px !important;
}
</style>